import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl } from 'components/ResolveImage/utils';
import { Listing } from 'models/Listing';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ListingPrices from 'components/ListingPrices';
import DocumentIcon from 'icons/Document.icon';
import useLocationMapper from 'router/data/useLocationMapper';
import { BUYING_PORTFOLIO_ROUTE, SELLING_PORTFOLIO_ROUTE } from 'data/global';

import './ListingInformation.styles.scss';

type ListingInformationProps = {
  className?: string;
  listing: Listing;
  isInterlocutorSeller: boolean;
  isExternalCommunication: boolean;
};

const ListingInformation: React.FC<ListingInformationProps> = (props) => {
  const { className, listing, isInterlocutorSeller, isExternalCommunication } =
    props;

  const { t } = useTranslation();

  const { locationLabelMapper } = useLocationMapper();

  const classes = classNames('listing-information', className);

  const locationStateLabel =
    locationLabelMapper[listing?.location?.state] ||
    listing?.locationPostcode ||
    listing?.dealLocation;

  return (
    <div className={classes}>
      <p>{t('dealYoureDiscussing')}</p>

      <div className="listing-information__main">
        <div>
          <p className="title">{listing?.listingTitle}</p>
          <p className="location">
            {`${locationStateLabel} - 
            ${listing?.industry}`}
          </p>
        </div>
        <ResolveImage src={getImgUrl(listing?.gallery?.[0]?.url, '240')} />
      </div>

      <ListingPrices
        askingPrice={listing?.askingPriceSelect}
        amount={listing?.amount}
        amountFrom={listing?.amountFrom}
        amountTo={listing?.amountTo}
        revenue={listing?.revenue}
        EBITDA={listing?.EBITDA}
        averageStockValue={listing?.averageStockValue}
        stockAtValue={listing?.stockAtValue}
        currency={listing?.currency}
      />

      <div className="listing-information__links">
        <Link
          to={`${
            isExternalCommunication
              ? SELLING_PORTFOLIO_ROUTE
              : isInterlocutorSeller
              ? BUYING_PORTFOLIO_ROUTE
              : SELLING_PORTFOLIO_ROUTE
          }/${
            isExternalCommunication
              ? listing?.dealRoomId
              : isInterlocutorSeller
              ? listing?.listingEnquiryId
              : listing?.dealRoomId
          }`}
        >
          <DocumentIcon />
          {t('viewInMyPortfolio')}
        </Link>
      </div>
    </div>
  );
};

export default ListingInformation;
